import {
  detectBot,
  isContentCodePresent,
  logUnknownError,
  logBotDetection,
  logTrafficBlock,
} from '@flipp/shopper-ad-web-shared';

export async function shouldBlockBotTraffic(): Promise<boolean> {
  try {
    const { botDetect, blockBotTraffic } = window.flippxp?.settings ?? {};
    const detectionResults = await detectBot();

    if (botDetect) {
      logBotDetection(detectionResults);
    }

    if (isContentCodePresent()) {
      return false;
    }

    const isBot = Object.values(detectionResults).some(Boolean);

    if (isBot && blockBotTraffic) {
      logTrafficBlock(detectionResults);
      return true;
    }

    return false;
  } catch (err) {
    logUnknownError(err);
    return false;
  }
}
